
import SnackbarComponent from "./snackbar.vue";
import Vue from 'vue';

const Snackbar = {
  install(Vue, options) {
    this.EventBus = new Vue();

    Vue.component("app-snackbar", SnackbarComponent);
    Vue.prototype.$snackbar = {
      show(params) {
        Snackbar.EventBus.$emit("show", params);
      },
      error(message) {
        Snackbar.EventBus.$emit("error", message);
      },
      success(message) {
        Snackbar.EventBus.$emit("success", message);
      },
      hide() {
        Snackbar.EventBus.$emit("hide");
      }
    };
  }
};

Vue.use(Snackbar);

export default Snackbar;